import { type ReactNode } from 'react';
import { Upload } from 'lucide-react';
import { useComposerMedia } from '../hooks/use-composer-media';
import { MediaThumbGrid, MAX_MEDIA, HINT } from './composer-media-thumb';

type Props = {
  comunicadoId: string | undefined;
  files: string[];
  onChanged: () => void;
};

const UB =
  'inline-flex items-center gap-xs rounded-md border border-white/[0.06] px-sm py-1 text-[12px] text-text-secondary hover:border-brand-red/40 hover:text-brand-red disabled:cursor-not-allowed disabled:opacity-40';
const HINT_CLS = 'text-[11px] text-text-tertiary';

function UploadHeader(p: {
  count: number;
  disabled: boolean;
  pending: boolean;
  onClick: () => void;
}): ReactNode {
  return (
    <div className="flex items-center justify-between">
      <label className="text-[12px] uppercase tracking-wide text-text-tertiary">
        Imágenes ({p.count}/{MAX_MEDIA})
      </label>
      <button
        type="button"
        disabled={p.disabled}
        onClick={p.onClick}
        className={UB}
      >
        <Upload size={12} /> {p.pending ? 'Subiendo…' : 'Subir'}
      </button>
    </div>
  );
}

function HintLine(p: {
  comunicadoId: string | undefined;
  count: number;
}): ReactNode {
  if (!p.comunicadoId)
    return <p className={HINT_CLS}>{HINT} (guarda primero para subir)</p>;
  if (p.count === 0) return <p className={HINT_CLS}>{HINT}</p>;
  return null;
}

function HiddenInput(p: {
  inputRef: React.RefObject<HTMLInputElement | null>;
  onPick: (files: globalThis.File[]) => void;
}): ReactNode {
  return (
    <input
      ref={p.inputRef}
      type="file"
      accept="image/*"
      multiple
      onChange={(e) => p.onPick(Array.from(e.target.files || []))}
      className="hidden"
    />
  );
}

export function ComposerMediaUpload(p: Props): ReactNode {
  const a = useComposerMedia(p);
  return (
    <div className="space-y-sm">
      <UploadHeader
        count={p.files.length}
        disabled={a.disabled}
        pending={a.pending}
        onClick={() => a.inputRef.current?.click()}
      />
      <HiddenInput inputRef={a.inputRef} onPick={a.onPick} />
      <HintLine comunicadoId={p.comunicadoId} count={p.files.length} />
      <MediaThumbGrid
        id={p.comunicadoId}
        files={p.files}
        onRemove={a.onRemove}
      />
    </div>
  );
}
